import app from 'flarum/forum/app';

/**
 * The text part of a search query in comparable form: gambits for `resource`
 * stripped (when given), whitespace collapsed, lowercased.
 */
export default function normaliseQuery(resource, query) {
  const text = resource ? app.search.gambits.match(resource, query, () => {}) : query;
  return text.trim().replace(/\s+/g, ' ').toLowerCase();
}
flarum.reg.add('glowingblue-search', 'forum/utils/normaliseQuery', normaliseQuery);